import {useCallback, useReducer} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {OauthClientModel} from '../../../models/api/oauthClientModel';
import {OauthClientEditorActionTypesEnum} from './oauthClientEditorActions';
import {oauthClientEditorReducer} from './oauthClientEditorReducer';
import {OauthClientEditorState} from './oauthClientEditorState';

export interface OauthClientEditorStateActions {
  onUpdateRedirectUrls: HandlerOf<string[]>;
}

export function useOauthClientEditorState(
  initialOauthClient: OauthClientModel | undefined,
): {oauthClientEditorState: OauthClientEditorState} & OauthClientEditorStateActions {
  const [oauthClientEditorState, dispatch] = useReducer(
    oauthClientEditorReducer,
    OauthClientEditorState.createInitialState(initialOauthClient),
  );

  const onUpdateRedirectUrls = useCallback((redirectUrls: string[]) => {
    dispatch({
      type: OauthClientEditorActionTypesEnum.UPDATE_REDIRECT_URLS,
      redirectUrls,
    });
  }, []);

  return {
    oauthClientEditorState,

    onUpdateRedirectUrls,
  };
}
